import {
  createContext, useEffect, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';
import useQueryWorkspaces from '../../hooks/useQueryWorkspaces';
import httpClient from '../../datasources/httpClient';

export const WorkspacesContext = createContext();

export default function WorkspacesProvider({ children }) {
  const [id, setId] = useState(null);
  const [workspace, setWorkspace] = useState(null);
  const { isFetching, data, isLoading } = useQueryWorkspaces();

  useEffect(() => {
    const fetchWorkspace = async () => {
      const response = await httpClient.get(`workspaces/${id}`);

      setWorkspace(response.data);
    };

    if (id) {
      fetchWorkspace();
    } else {
      setWorkspace(null);
    }
  }, [id]);

  const value = useMemo(() => ({
    isFetching,
    isLoading,
    workspaces: data ?? [],
    workspace,
    setId,
    setWorkspace,
  }), [isFetching, isLoading, data, workspace]);

  return (
    <WorkspacesContext.Provider value={value}>
      {children}
    </WorkspacesContext.Provider>
  );
}

WorkspacesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
